import { useAppSelector, useMainSidebarActions } from '@nx/state';

import type { SideNavProps } from './side-nav';
import { SideNav } from './side-nav';

export function MainLeftNav({ items }: { items: SideNavProps['items'] }) {
  const { togglePinnedSideNav } = useMainSidebarActions();
  const isPinnedOpen = useAppSelector((state) => state.sidebar.newMainSideNav.isPinnedOpen);

  return (
    <SideNav
      isExpanded={isPinnedOpen}
      shouldExpandOnHover={true}
      pinButtonCallback={() => togglePinnedSideNav()}
      items={items}
      style={{ zIndex: 21 }}
    />
  );
}
